import { useAppModeStore } from '@shared/config/appMode.store'

export const AppModeProvider = ({ children }: { children?: React.ReactNode }) => {
    const mode = useAppModeStore((s) => s.mode)

    return (
        <div data-app-mode={mode}>
            {children}
        </div>
    )
}
